export default __webpack_public_path__ + "static/media/11.a42bf9d5.jpeg";